import { Alert, Box, Typography } from '@mui/material';
import { updateUser } from 'APIs/AuthApi';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { NormalButton } from 'components/atoms/Button';
import Loader from 'components/atoms/loader';
import { selectAuth, updateCategories } from 'features/auth/authSlice';
import { updatePreferredCategories } from 'features/auth/nftSlice';
import { NftType } from 'interfaces/NftData.interface';
import React, { SetStateAction, useState } from 'react';
import BasicModal from '../Modal';
import Categories from './Categories';
import './styles.css';

interface ICateogryModalProps {
  openModal: boolean;
  setOpenModal: SetStateAction<any>;
}

const CateogryModal: React.FC<ICateogryModalProps> = ({
  openModal,
  setOpenModal,
}) => {
  const handleClose = () => {
    setOpenModal(false);
  };
  const [categories, setCategories] = useState<NftType[]>([]);
  const [success, setSuccess] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const authState = useAppSelector(selectAuth);
  const dispatch = useAppDispatch();
  const submitCategories = async () => {
    setLoading(true);
    try {
      const res = await updateUser({
        id: authState.id,
        preferredCategories: categories,
      });
      if (res) {
        setSuccess(true);
        setError(false);
        dispatch(updateCategories(categories));
        dispatch(updatePreferredCategories(categories));
      }
    } catch (error) {
      console.log(error);
      setSuccess(false);
      setError(true);
    }
    setLoading(false);
  };
  return (
    <div>
      <BasicModal open={openModal} handleClose={handleClose}>
        <>
          <img alt="" />
          <Typography
            sx={{ textAlign: 'center', color: 'white', marginBottom: '40px' }}
            id="modal-modal-title"
            variant="h6"
            component="h2"
          >
            Select your preferred categories...
          </Typography>
          {success && (
            <Alert
              onClose={() => setSuccess(false)}
              sx={{ mb: 2 }}
              severity="success"
            >
              Your preferred categories have been set successfully.
            </Alert>
          )}
          {error && (
            <Alert
              onClose={() => setError(false)}
              sx={{ mb: 2 }}
              severity="error"
            >
              There was an error in setting your preferred categories.
            </Alert>
          )}
          <Categories categories={categories} setCategories={setCategories} />
          <Box>
            <Typography
              sx={{ textAlign: 'center', color: 'white', marginTop: '40px' }}
              id="modal-modal-title"
              variant="h6"
              component="h2"
            >
              Explicit and Sensitive Content
            </Typography>
            <div style={{ display: 'flex', marginTop: '10px' }}>
              <input
                style={{
                  alignSelf: 'start',
                  marginTop: '2px',
                  marginRight: '5px',
                }}
                type="checkbox"
                defaultChecked
              />
              <span
                style={{
                  color: 'white',
                  opacity: 0.9,
                  textAlign: 'center',
                  fontSize: '15px',
                }}
              >
                I am atleast 18 years of age, and by enabling this option i may
                run into content which may be considered explicit or sensitive.
              </span>
            </div>
          </Box>
          <NormalButton
            text={loading ? <Loader size="2" /> : 'Confirm'}
            color="yellow"
            sx={{
              width: '100%',
              textTransform: 'uppercase',
              marginTop: '50px',
            }}
            onClick={submitCategories}
          />
        </>
      </BasicModal>
    </div>
  );
};

export default CateogryModal;
